class MediaGallery extends HTMLElement {
  GAP = 8;
  MAIN_IMAGE = this.querySelector("[data-main-media]");

  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.touchMoveX = 0;
    this.touchMoveY = 0;
    this.isHorizontalSwipe = false;

    this.mainImage = this.querySelector("[data-main-media]");
    this.thumbnailsContainer = this.querySelector("[data-thumbnail-container]");

    this.thumbnails = this.querySelectorAll("[data-thumbnail-media]");
    this.prevButton = this.querySelector("[data-gallery-prev]");
    this.nextButton = this.querySelector("[data-gallery-next]");

    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", () => {
        this.currentIndex = index;
        this.updateMainImage();
        this.updateThumbnails();
      });
    });

    if (this.prevButton) {
      this.prevButton.addEventListener(
        "click",
        this.showPreviousImage.bind(this)
      );
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", this.showNextImage.bind(this));
    }
    this.mainImage.addEventListener(
      "touchstart",
      this.handleTouchStart.bind(this),
      { passive: false }
    );
    this.mainImage.addEventListener(
      "touchmove",
      this.handleTouchMove.bind(this),
      { passive: false }
    );
    this.mainImage.addEventListener("touchend", this.handleTouchEnd.bind(this));

    if (this.thumbnails.length > 0) {
      this.updateMainImage();
      this.updateThumbnails();
    }
  }

  connectedCallback() {
    window.addEventListener(
      "resize",
      debounce(this.updateThumbnails.bind(this), 300)
    );
  }

  updateMainImage() {
    this.mainImage.src = this.thumbnails[this.currentIndex].dataset.mediaUrl;
  }

  updateThumbnails() {
    const containerRect = this.thumbnailsContainer.getBoundingClientRect();
    this.thumbnails.forEach((thumbnail, index) => {
      const thumbnailRect = thumbnail.getBoundingClientRect();
      if (index === this.currentIndex) {
        thumbnail.classList.add("opacity-100");
        thumbnail.classList.remove("opacity-25", "lg:opacity-60");
        if (thumbnailRect.left < containerRect.left) {
          this.thumbnailsContainer.scrollLeft -=
            containerRect.left - thumbnailRect.left + this.GAP;
        } else if (thumbnailRect.right > containerRect.right) {
          this.thumbnailsContainer.scrollLeft +=
            thumbnailRect.right - containerRect.right + this.GAP;
        }
      } else {
        thumbnail.classList.remove("opacity-100");
        thumbnail.classList.add("opacity-25", "lg:opacity-60");
      }
    });

    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex >= this.thumbnails.length - 1;
  }

  showPreviousImage() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
      this.updateMainImage();
      this.updateThumbnails();
    }
  }

  showNextImage() {
    if (this.currentIndex < this.thumbnails.length - 1) {
      this.currentIndex += 1;
      this.updateMainImage();
      this.updateThumbnails();
    }
  }

  handleTouchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
    this.isHorizontalSwipe = false;
  }

  handleTouchMove(event) {
    this.touchMoveX = event.changedTouches[0].screenX;
    this.touchMoveY = event.changedTouches[0].screenY;

    const diffX = Math.abs(this.touchMoveX - this.touchStartX);
    const diffY = Math.abs(this.touchMoveY - this.touchStartY);

    if (diffX > diffY) {
      this.isHorizontalSwipe = true;
      event.preventDefault(); // Prevents the whole page from moving if it's a horizontal swipe
    }
  }

  handleTouchEnd(event) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.touchEndY = event.changedTouches[0].screenY;

    if (this.isHorizontalSwipe) {
      this.handleSwipeGesture();
    }
  }

  handleSwipeGesture() {
    if (this.touchStartX - this.touchEndX > 50) {
      this.showNextImage();
    } else if (this.touchStartX - this.touchEndX < -50) {
      this.showPreviousImage();
    }
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
